wbApp.directive('wbIsAfterValidator', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {

            scope.$watch(attr.wbIsAfterValidator, function (value) {
                var val = value;

                if (moment.isDate(val) && moment.isDate(ctrl.$modelValue))
                {
                    ctrl.$setValidity('isAfter', moment(ctrl.$modelValue).isAfter(val));
                } else {
                    ctrl.$setValidity('isAfter', true);
                }
            });

            scope.$watch(attr.ngModel, function (model) {
                var val = scope.$eval(attr.wbIsAfterValidator);

                if (moment.isDate(val) && moment.isDate(ctrl.$modelValue)) {
                    ctrl.$setValidity('isAfter', moment(ctrl.$modelValue).isAfter(val));
                } else {
                    ctrl.$setValidity('isAfter', true);
                }
            });
        }
    };
}]);